import React from 'react';
import Logo from '../components/Logo';
import Mouse from '../components/Mouse';
import Navigation from '../components/Navigation';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SocialNetwork from '../components/SocialNetwork';
import ButtonsBottom from '../components/ButtonsBottom';
import ContactForm from '../ContactForm';

function Contact() {
    return (
        <main>
            <Mouse />
            <div className="contact">
                <Navigation />
                <Logo />
                <ContactForm />

                <div className="contact-infos">
                    <div className="address">
                        <div className="content">
                            <h4>Adresse</h4>
                            <p>41, avenue Frontière</p>
                            <p>11018 Kinshasa / Gombe</p>
                        </div>
                    </div>

                    <div className="phone">
                        <div className="content">
                            <h4>Téléphone</h4>
                            <CopyToClipboard text="+243824448766" className="hover">
                                <p style={{ cursor: 'pointer' }} className="clipboard" onClick={() => {
                                    alert('Téléphone copié !');
                                }}>+243 82 444 87 66</p>
                            </CopyToClipboard>
                        </div>
                    </div>

                    <div className="email">
                        <div className="content">
                            <h4>Email</h4>
                            <CopyToClipboard text="ommartiste007@gmail.com" className="hover">
                                <p style={{ cursor: 'pointer' }} className="clipboard" onClick={() => {
                                    alert('Email copié !');
                                }}>ommartiste007@gmail.com</p>
                            </CopyToClipboard>
                        </div>
                    </div>

                    <SocialNetwork />
                    <div className="credits">
                        <p>Obed MULUMBA - 2021</p>
                    </div>
                </div>

                <ButtonsBottom left={'/project-4'} />
                
            </div>
        </main>
    )
}

export default Contact
